export const oauthSignUp = {
  heading: "Create your free Fullscript account",
  subheading:
    "Create your Fullscript account to access Academy and everything else Fullscript offers. One login. Full access.",
  heroAlt: "Preview of Fullscript Academy and Fullscript",
  marketingCard: {
    title: "You’ll also get access to Fullscript!",
    body: "Put learning into practice with Fullscript. Access trusted supplements, leading labs, personalized care tools, and streamlined workflows designed to help you achieve better patient outcomes.",
    learnMoreLink: "Learn more about being a Fullscript provider.",
  },
  fields: {
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    password: "Password",
  },
  tos: "I agree to Fullscript’s <tos>Terms of Service</tos> and <privacy>Privacy Statement</privacy>",
  tosAriaLabel: "I agree to Fullscript’s Terms of Service and Privacy Statement",
  errors: {
    firstNameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    emailRequired: "Email is required",
    emailInvalid: "Please enter a valid email address",
    passwordRequired: "Password is required",
    tosRequired: "Please agree to ToS and Privacy Statement before continuing",
  },
  continue: "Continue",
  createAccount: "Create account",
  stepAnnouncement: "Step {{current}} of {{total}}",
  signInPrompt: "Already have an account?",
  signInLink: "Sign in",
  notFound: {
    title: "Page not found",
    message: "The page you're looking for isn't available. Try signing in to your account instead.",
    signInCta: "Go to sign in",
  },
} as const;
